import { Dispatch, SetStateAction } from 'react';

import { AccessLevel, UserApiKeyDataSerialized, UserApiKeySerialized } from '@playq/octopus2-auth';
import { TgDuration } from '@playq/services-shared';

import { ITableColumn, ITableQuery, ITableRowAction } from '/shared/Table/interfaces';
import { IGenericTableEntity } from '/common/models';

export type ApiKeyDataToCopy = UserApiKeySerialized | null;
export type ExistingApiKeyIdBeingProcessed = number | null;
export type KeyCreationDialogTogglingHandler = Dispatch<SetStateAction<boolean>>;
export type KeyFormSubmissionHandler = ({
  keyName,
  keyAccessLevel,
  ttl,
  tableQuery,
  id,
}: {
  keyName: string;
  keyAccessLevel: AccessLevel;
  ttl?: TgDuration;
  tableQuery: ITableQuery<string>;
  isCreateMode: boolean;
  id?: number;
}) => void;
export type TableEntriesSettingHandler = (data: IGenericTableEntity[]) => void;

export interface IApiKeyCreationMetadata {
  isKeyCreationBeingProcessed: boolean;
  isKeyRegenerationBeingProcessed: boolean;
  newKeyName: string;
  newTtl: TgDuration | undefined;
  newKeyAccessLevel: AccessLevel;
  tableQueryToPerformAfterKeyCreation: ITableQuery<string> | null;
  tableQueryToPerformAfterKeyRegeneration: ITableQuery<string> | null;
  id: number | undefined;
}

export interface IIndependentApiKeysTableContentMetadata {
  columns: ITableColumn<UserApiKeyDataSerialized, ApiKeysQueryFields>[];
  rowKeyResolver: (entry: UserApiKeyDataSerialized) => number;
}

export interface IDependentApiKeysTableContentMetadata {
  data: UserApiKeyDataSerialized[];
  rowActions: ITableRowAction<UserApiKeyDataSerialized>[];
}

export interface IApiKeysTableContentMetadata
  extends IIndependentApiKeysTableContentMetadata, IDependentApiKeysTableContentMetadata {}

export enum ApiKeysQueryFields {
  ID = 'id',
  Name = 'name',
  CreatedAt = 'created',
  LastUsedAt = 'lastUsed',
  Expiration = 'expiration',
  TTL = `ttl`,
}

export interface IKeyCreationProcessingConfig {
  id?: number;
  isCreationBeingProcessed: boolean;
  isKeyRegenerationBeingProcessed: boolean;
  keyName?: string;
  keyAccessLevel?: AccessLevel;
  ttl?: TgDuration;
  tableQuery?: ITableQuery<string>;
}
